module.exports = new __parcel__URL__("brawler_cage_level_1.0f2c4438.png").toString();